export default {
  name: 'select',
  label: '下拉框',
  icon: 'el-icon-takeaway-box',
  config: [{
    // 可修改的配置选项
    xtype: 'text',
    options: {
      label: '输入提示',
      name: 'placeholder',
      default: '请在列表中选择'
    }
  }, {
    // 可修改的配置选项
    xtype: 'option-list',
    options: {
      label: '选项列表',
      name: 'options',
      default: [{
        label: '选项1',
        value: '选项1'
      }, {
        label: '选项2',
        value: '选项2'
      }, {
        label: '选项3',
        value: '选项3'
      }]
    }
  }]
};